import { render, staticRenderFns } from "./side-navbar.vue?vue&type=template&id=0aeb291d&scoped=true&"
import script from "./side-navbar.vue?vue&type=script&lang=js&"
export * from "./side-navbar.vue?vue&type=script&lang=js&"
import style0 from "./side-navbar.vue?vue&type=style&index=0&id=0aeb291d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeb291d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aeb291d')) {
      api.createRecord('0aeb291d', component.options)
    } else {
      api.reload('0aeb291d', component.options)
    }
    module.hot.accept("./side-navbar.vue?vue&type=template&id=0aeb291d&scoped=true&", function () {
      api.rerender('0aeb291d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/navbar/side-navbar.vue"
export default component.exports